<template>
    <div>
        <ul class="side-menu" v-if="showMenu" ref="sideMenu">
            <!-- 推广隐藏 -->
            <!-- <li @mouseover="handwechat" @mouseout="handwechat">
                <a class="iconfont" title="Wechat">&#xe73b;</a>
                <div class="wechats">
                    <img src="https://admin.huashengdaili.com/images/download/20.18.9.12.jpg" alt="">
                    <p>扫一扫 花生家族微信huashengdaili</p>
                </div>
            </li> -->
            <li>
                 <a href="https://wpa.qq.com/msgrd?v=3&uin=2113166507&site=qq&menu=yes" target="_blank" class="iconfont" title="QQ">&#xe65e;</a>
            </li>
             <li @click="goTop" @touch="goTop">
                <a class="iconfont" title="返回顶部">&#xe638;</a>
            </li>
        </ul>
    </div>
</template>

<script>
export default {
    name: 'Side',
    data () {
        return {
            showMenu: false,
            scrollTop: 0
        }
    },
    mounted () {
        window.addEventListener('scroll', this.handleScroll)
    },
    methods: {
        handleScroll () {
            this.scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
            this.showMenu = true
            if(this.$refs.sideMenu){
                this.$refs.sideMenu.style.right = `0rem`
            }
        },
        goTop () {
            let timer
            let _this = this
            cancelAnimationFrame(timer)
            timer = requestAnimationFrame(function fn(){
                if(_this.scrollTop>0){
                    _this.scrollTop -= 50
                    document.body.scrollTop = document.documentElement.scrollTop = _this.scrollTop
                    timer = requestAnimationFrame(fn) //递归
                }else{
                    cancelAnimationFrame(timer)
                }
            })
        },
        handwechat () {
            let wechat = document.querySelector(".wechats")
            wechat.classList.forEach(item => {
                if(item == 'wechatAn'){
                    wechat.classList.remove("wechatAn")
                    return
                }else{
                    wechat.classList.add("wechatAn")
                    return
                }
            })
        }
    },
    watch: {
        scrollTop () {
            if(this.scrollTop === 0) {
                if(this.$refs.sideMenu){
                    this.$refs.sideMenu.style.right = `-1.2rem`
                    var _this = this
                    // setTimeout(function(){
                    //     _this.showMenu = false
                    // },1000)
                }
            }
        }
    }
}
</script>

<style lang="stylus" scoped>
    .side-menu
        width 1rem
        position fixed
        right -1rem
        top 80%
        margin-top -0.5rem
        box-shadow 1px 2px 8px #bda9a9
        transition all .36s ease-in-out
        background #fff
        z-index 99
    .side-menu .wechats
        position absolute
        left -400px
        top -50px
        width 200px
        height auto
        background #fff
        border-radius 2px
        opacity 0
        display none
        animation all 2s ease
        background #29d3a0
        color #ffffff
    .side-menu .wechatAn
        position absolute
        left -200px
        top -50px
        opacity 1
        display block
    .side-menu .wechats img
        width 150px
        height 150px
        padding 10px
        text-align left
        background #29d3a0
    .side-menu li
        height 1rem
        line-height 1rem
        text-align center
        border 1px solid #efeeee
        cursor pointer
    .side-menu li a
        width 100%
        height 100%
        display block
        font-size 36px
    // .side-menu li:nth-child(1) a
    //     color #4caf50
    .side-menu li:nth-child(1) a
        color #2196f3
    .side-menu li:nth-child(2) a
        color #353535
        font-size 26px
    .side-menu li span:hover{
        background #eee
    }

</style>


// WEBPACK FOOTER //
// src/pages/Side/Side.vue